/**
 * The `isPdfImportEnabled` gate, kept in its own module so it can be imported
 * without pulling in polotno — `BayPolotnoEditor/index.tsx` cannot load under
 * Node's ESM loader (see KNOWN_BAD_DEPS in `src/index.test.ts`), so a rule that
 * lives there is untestable.
 */
export const PDF_LIKE_IMPORT_KEYS = new Set(['pdf', 'ai']);

/**
 * The single place the gate is applied. A consumer that renders its own Import
 * menu filters through this instead of restating the rule: an unfiltered list
 * shows PDF/AI entries whose clicks `handleImportOptionSelect` then silently
 * discards, which is exactly what ticket 12996093209 reported.
 */
export const filterDesignImportOptions = <T extends { key?: string }>(
	options: T[],
	isPdfImportEnabled: boolean,
): T[] =>
		isPdfImportEnabled
			? options
			: options.filter(
				(option) => !(option.key && PDF_LIKE_IMPORT_KEYS.has(option.key)),
			);
